var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37591 19.1667H4.89708C2.65675 19.1667 0.833496 17.3435 0.833496 15.1013V4.89971C0.833496 2.65754 2.65675 0.833374 4.89708 0.833374H9.36583C11.608 0.833374 13.4322 2.65754 13.4322 4.89971V5.75404C13.4322 6.13354 13.1242 6.44154 12.7447 6.44154C12.3652 6.44154 12.0572 6.13354 12.0572 5.75404V4.89971C12.0572 3.41471 10.8499 2.20837 9.36583 2.20837H4.89708C3.41483 2.20837 2.2085 3.41471 2.2085 4.89971V15.1013C2.2085 16.5854 3.41483 17.7917 4.89708 17.7917H9.37591C10.8536 17.7917 12.0572 16.589 12.0572 15.1114V14.247C12.0572 13.8675 12.3652 13.5595 12.7447 13.5595C13.1242 13.5595 13.4322 13.8675 13.4322 14.247V15.1114C13.4322 17.348 11.6117 19.1667 9.37591 19.1667Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1495_13510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 13,
    height: 2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24609 9.3125H19.6586V10.6875H7.24609V9.3125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1495_13510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9712 10.6875H7.93359C7.55409 10.6875 7.24609 10.3795 7.24609 10C7.24609 9.6205 7.55409 9.3125 7.93359 9.3125H18.9712C19.3507 9.3125 19.6587 9.6205 19.6587 10C19.6587 10.3795 19.3507 10.6875 18.9712 10.6875Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1495_13510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 6,
    width: 5,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6006 6.64062H19.659V13.3605H15.6006V6.64062Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1495_13510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2879 13.3605C16.1119 13.3605 15.9349 13.2936 15.8011 13.1579C15.5334 12.8884 15.5344 12.4539 15.8029 12.1862L17.9974 9.99998L15.8029 7.81465C15.5344 7.54698 15.5325 7.11248 15.8011 6.84298C16.0688 6.57348 16.5033 6.57348 16.7728 6.84115L19.4568 9.51323C19.5869 9.64156 19.6594 9.81756 19.6594 9.99998C19.6594 10.1824 19.5869 10.3584 19.4568 10.4867L16.7728 13.1597C16.6389 13.2936 16.4629 13.3605 16.2879 13.3605Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.9375bea5ec59b04003f65833f2f2ce15.svg";
export { ForwardRef as ReactComponent };